module.exports = __webpack_public_path__ + "static/JetBrainsMono-Medium-Italic-2bd2a4a1613cb57da6e469ba6f2ecc93.woff";